<template>
    <div class="pagination">
        <template v-for="page in totalPagesArray" :key="page">
            <div v-if="showDotsBefore(page)">
                ...
            </div>
             <div 
                class="pagination__link" 
                @click="doClick(page)" :class="{
                    'pagination__link--active': page === pagination.currentPage
                }" 
                v-if="showPageButton(page)"
            
            >
                <span >{{ page }}</span>
            </div>
            <div v-if="showDotsAfter(page)">
                ...
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: ["pagination"],
    data() {
        return {}
    },
    methods: {
        doClick: function (e) {
            this.$emit("pagination-click", e)
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        },
        showPageButton: function (page) {
            if (
                page == 1
            ) {
                return true;
            } 

            if (page < this.pagination.currentPage + 5 &&
                page > this.pagination.currentPage - 5) {
                return true;
            }

            if (page == this.pagination.totalPages) {
                return true;
            }
            
            return false;
            
        },
        showDotsBefore: function (page) {


            if (
                page == this.pagination.totalPages &&
                this.pagination.currentPage < this.pagination.totalPages - 5
            ) {
                return true;
            }
            
            return false;
            
        },
        showDotsAfter: function (page) {
            if (
                page == 1 &&
                this.pagination.currentPage > 5
            ) {
                return true;
            } 

            
            
            return false;
            
        },
    },
    computed: {
        
        totalPagesArray: function () {
            let array = [...Array(this.pagination.totalPages + 1).keys()];
            return array.slice(1, this.pagination.totalPages + 1);
        }
    }
}
</script>
